module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "header"
  }, [_c('tr', [_vm._l((_vm.columns), function(item) {
    return [(item.hour) ? _c('th', [_c('span', [_vm._v(_vm._s(item.hour) + ":00")]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, _vm._l((12), function(i) {
      return _c('i')
    }), 0)]) : _c('th', [_vm._v(_vm._s(item.title))])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3f1558c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lesson/TimetableHeader.vue
// module id = 1974
// module chunks = 8